<div [ngClass]="['chip', background()]" [attr.aria-label]="text()">
  {{ text() }}
</div>
